import actions from './actions';
import mutations from './mutations';

const state = {
    isLoading: false,
    // Последний запрос сводки упал: страница показывает блок «Не удалось загрузить данные»
    // вместо нулевых заглушек, которые читались бы как валидные цифры.
    loadError: false,
    // Бэкенд отдаёт только rated: исполнители без видимых оценок в рейтинг не попадают вовсе,
    // а прежний блок unrated здесь всё равно никогда не рендерился (EnpsRankingTable.vue).
    ranking: { rated: [] },
    overall: { averageRating: null, ratingsCount: 0 },
    categoryChart: { top: [], rest: null },
    categoryList: [],
    ratedShare: { ratedCount: 0, closedCount: 0, percentage: null },
    topRatingsShare: { topCount: 0, totalCount: 0, percentage: null },
    departmentBreakdown: { top: [], rest: null },
    resolutionTimeBuckets: [],
    problemCategories: [],
    // Лента последних низких оценок за период — конкретные случаи под агрегатами.
    recentLowRatings: [],
};

export default {
    state,
    actions,
    mutations,
};
